<template>
	<div class="home">
		<van-nav-bar fixed border>
			<template #title :style="{'max-width':'80%'}">
				<form action="#">
					<van-search
					  v-model.trim="keywords"
					  placeholder="查询店铺、商品名称"
					  shape="round"
					  background="transparent"
					  @focus="searchFocus=true"
					  @blur="searchFocus=false"
					  @search="onRefresh"
					  :style="{'padding':'3px 0px'}"
					>
					</van-search>
				</form>
			</template>
			<template #right>
				<van-icon name="shopping-cart-o" :dot="shoppingDot" @click="goShoppingCart" :style="{'margin-right':'5px'}"/>
				<van-icon name="location-o" @click="showLocationByAmap" dot/>
			</template>
		</van-nav-bar>
		<div class="collapse">
		
			<van-swipe :autoplay="3000" v-if="banners.length>0">
				<van-swipe-item v-for="(banner, index) in banners" :key="index" @click="goForBanner(banner)">
					<img :src="attach_url+banner.img" :style="{width:'100%',height:'100%'}"/>
					<span class="title" v-if="banner.title&&banner.title.trim()!=''">{{banner.title.trim()}}</span>
				</van-swipe-item>
			</van-swipe>

			<van-notice-bar
				left-icon="volume-o"
				:scrollable="(noticeBarStr&&noticeBarStr.length>65)"
				:style="{padding:0,'font-size':'12px'}"
				v-if="noticeBarStr!=''"
				@click="reshowNotice"
			>
				<span slot="default" v-html="noticeBarStr"></span>
			</van-notice-bar>

			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<div class="empty empty_street" v-if="items.length==0"></div>
				<van-list
				v-model="loading"
				:finished="finished"
				:finished-text="items.length==0?(keywords==''?'方圆十里还没有你熟悉的店铺':'方圆十里没有你找的店铺或商品'):'没有更多店铺了'"
				@load="loadData"
				>
					<van-card
					  :title="item.s_name"
					  :tag="(item.s_close_from&&item.s_close_to)?'休业':(item.express?'可配送':'')"
					  :thumb="attach_url+item.s_img"
					  v-for="(item,index) in items"
					  :key="index"
					  @click="goStore(item.s_id)"
					>
						<template #desc>
							<div class="van-card__desc van-ellipsis"><van-icon name="location-o" />{{item.s_address}}</div>
						</template>
						<template #tags v-if="item.env_img">
							<div :style="{'padding-left':'12px'}">
								<img :src="attach_url+uri" v-for="(uri,i) in item.env_img.split(',')" :key="i" :style="{height:'30px','margin-right':'5px'}" @click.stop="previewEnvImg(item.env_img, i)"/>
							</div>
						</template>
						<template #num>
							{{item.distance|distance_format}}
						</template>
						<template #price>
							<van-icon name="phone-o" /><a :href="'tel:' + item.s_telphone" @click.stop="" class="van-card__desc">{{item.s_telphone}}</a>
						</template>
						<template #footer v-if="item.s_close_from&&item.s_close_to">
							{{item.s_close_from*1000|moment_format('YYYY-MM-DD HH:mm')}} ~ {{item.s_close_to*1000|moment_format('YYYY-MM-DD HH:mm')}}（休业时间）
						</template>
					</van-card>
				</van-list>
			</van-pull-refresh>

			<van-divider v-if="finished&&items.length==0">为您推荐</van-divider>

			<van-card
			  :title="item.s_name"
			  :tag="(item.s_close_from&&item.s_close_to)?'休业':(item.express?'可配送':'')"
			  :thumb="attach_url+item.s_img"
			  v-for="(item,index) in recommendItems"
			  :key="index"
			  @click="goStore(item.s_id)"
			>
				<template #desc>
					<div class="van-card__desc van-ellipsis"><van-icon name="location-o" />{{item.s_address}}</div>
				</template>
				<template #tags v-if="item.env_img">
					<div :style="{'padding-left':'12px'}">
						<img :src="attach_url+uri" v-for="(uri,i) in item.env_img.split(',')" :key="i" :style="{height:'30px','margin-right':'5px'}" @click.stop="previewEnvImg(item.env_img, i)"/>
					</div>
				</template>
				<template #num>
				</template>
				<template #price>
					<van-icon name="phone-o" /><a :href="'tel:' + item.s_telphone" @click.stop="" class="van-card__desc">{{item.s_telphone}}</a>
				</template>
				<template #footer v-if="item.s_close_from&&item.s_close_to">
					{{item.s_close_from*1000|moment_format('YYYY-MM-DD HH:mm')}} ~ {{item.s_close_to*1000|moment_format('YYYY-MM-DD HH:mm')}}（休业时间）
				</template>
			</van-card>

		</div>

		<van-popup v-model="showAmap" position="bottom" :style="{ 'max-height': '80%', 'bottom':'60px'}" @close="onRefresh">
			<div id="amap_container_shop" class="amap_container"></div>
		</van-popup>

		<van-dialog 
			v-model="showNoticePopup" 
			messageAlign="left"
			className="main_notice"
			:title="notices[showedNoticeInd]?notices[showedNoticeInd]['title']:'公告'" 
			:confirmButtonText="showedNoticeInd==(notices.length-1)?'已阅读':'下一条'"
			:dialog-header-font-weight="600"
			@confirm="showOrCloseNoticePopup"
			:beforeClose="beforeCloseNoticePopup"
			:message="notices[showedNoticeInd]?notices[showedNoticeInd]['content']:''"
		>
		</van-dialog>
	</div>
</template>

<script type="text/ecmascript-6">
import { chkImgType,chkURL } from "@/utils/common.js";
import { List, Card,Search, Divider,ImagePreview ,Swipe, SwipeItem} from "vant";

export default {
	name: "store",
	components: {
		"van-list": List,
		"van-card": Card,
		"van-search":Search,
		"van-divider":Divider,
		"van-swipe":Swipe,
		"van-swipe-item":SwipeItem
	},
	data() {
		return {
			title: "",
			attach_url:this.Conf.serverPre,
			keywords:'',
			searchFocus:false,
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			showAmap:false,
			amapMarker:false,

			items: [],
			page:0,
			pageSize:0,
			total:0,
			loading: false,
			finished: false,
			refreshing: false,

			processList:[],
			showUploader:false,
			imgList:[],
			imgSizeLimit:500 * 1024,
			cur_s_id:-1,
			showAccount:false,
			showExpress:false,
			express:{expressList:[]},
			shoppingDot:false,
			banners:[],
			notices:[],
			noticeBarStr:'',
			showedNotice:false,
			showNoticePopup:false,
			showedNoticeInd:0,
			recommendItems:[],
			recommendPage:1
		};
	},
	mounted() {
		// 获取浏览器可视区域高度
		this.winH = `${document.documentElement.clientHeight}`;
		window.onresize = function temp() {
			this.winH = `${document.documentElement.clientHeight}`;
		};
		
	},
	created() {
		this.getStateConfigs();
		this.loadData();
		let storageShoppingCart = localStorage.getItem("myShoppingCart")?JSON.parse(localStorage.getItem("myShoppingCart")):{};
		this.shoppingDot = Object.keys(storageShoppingCart).length>0;
		this.showedNotice = localStorage.getItem("showedNotice") || false;
		this.getBanners();
		this.getNotices();
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		markerAmap(lnglat){
			if(this.amapMarker){
				this.amap.remove(this.amapMarker);
			}
			this.amapMarker = new AMap.Marker();
			this.amapMarker.setPosition(lnglat);
			this.amap.add(this.amapMarker);
			this.amap.setFitView(this.amapMarker);
		},
		showLocationByAmap(){
			this.showAmap=true;

			let that = this;
			this.$nextTick(() => {
				that.amap = new AMap.Map("amap_container_shop", {
					resizeEnable: true
				});
				that.amap.on('click', function(e) {
					that.markerAmap([e.lnglat.getLng(), e.lnglat.getLat()]);
					localStorage.setItem("lnglat", e.lnglat.getLng()+","+e.lnglat.getLat());
				});
				if(localStorage.getItem("lnglat")){
					that.markerAmap(localStorage.getItem("lnglat").split(","));
				}
			});
		},
		getBanners(){
			var url = this.Conf.serverUrl + "banner/list" + "?lnglat="+localStorage.getItem("lnglat")+"&num="+Math.random();
			this.$axios
			.get(url)
			.then(response => {
				if (response.data.code == 200) {
					this.banners = response.data.data;
				}
			})
			.catch(error => {});
		},
		getNotices(){
			var url = this.Conf.serverUrl + "notice/list" + "?lnglat="+localStorage.getItem("lnglat")+"&num="+Math.random();
			this.$axios
			.get(url)
			.then(response => {
				if (response.data.code == 200) {
					let datas = response.data.data;
					for(var i in datas){
						this.noticeBarStr += '<span style="margin-left:'+(i>0?50:0)+'px">' + datas[i].content + "</span>";
						if(datas[i].types == 2){
							this.notices.push(datas[i]);
						}
					}
					let logined = this.u_id && this.token;
					if ( this.notices.length > 0 && (!logined || (logined && !this.showedNotice)) ) {
						this.showNoticePopup = true;
					}
				}
			})
			.catch(error => {});
		},
		showOrCloseNoticePopup() {
			if (this.showedNoticeInd == this.notices.length - 1) {
				if (this.u_id && this.token) {
					this.showedNotice = true;
					localStorage.setItem("showedNotice", true);
				}
			} else {
				this.showedNoticeInd++;
			}
		},
		beforeCloseNoticePopup(action, done) {
			if (this.showedNotice) {
				done();
			}else{
				done(false);
			}
		},
		reshowNotice(){
			if(this.notices.length > 0){
				this.showedNotice = false;
				this.showNoticePopup = true;
				this.showedNoticeInd=0;
			}
		},
		loadData() {
			if (this.finished) {
				return false;
			}
			this.loading = true;
			setTimeout(() => {
				if (this.refreshing) {
					this.items = [];
					this.refreshing = false;
				}
				this.page = this.page+1;

				var params = {
					page: this.page,
					lnglat: localStorage.getItem("lnglat"),
					keywords:this.keywords
				};
				var url = this.Conf.serverUrl + "Store/around" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
						if (response.data.page == 1) {
							this.pageSize = response.data.pageSize;
							this.total = response.data.total;
							this.items = response.data.stores;
							if(this.total == 0){
								this.loadRecommendData();
							}
						}else if(response.data.stores){
							this.items = this.items.concat(response.data.stores);
						}
						if(this.page*this.pageSize >= this.total){
							this.finished = true;
						}
				})
				.catch(error => {});
			}, 1000);
		},
		loadRecommendData(rpage){
			var params = {
				page: rpage||1,
				lnglat: localStorage.getItem("lnglat"),
				keywords:this.keywords
			};
			var url = this.Conf.serverUrl + "Store/recommend" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				this.recommendItems = response.data.stores;
				this.recommendPage = Math.ceil(response.data.total/response.data.pageSize);
			})
			.catch(error => {});
		},
		onRefresh(cur){
			this.finished = false;
			this.page = cur?(this.page-1):0;
			this.loadData();
		},
		previewEnvImg(imgs, i){
			imgs = imgs.split(",");
			var imgarr = [];
			for(var ii in imgs){
				imgarr.push(this.attach_url+imgs[ii]);
			}
			ImagePreview({
				images: imgarr,
				startPosition: i,
				showIndex:false,
				showIndicators:true
			});
		},
		goStore(s_id) {
			this.$router.push({
				path: "Shopping/"+s_id
			});
		},
		goShoppingCart(){
			this.$router.push({
				path: "Cart"
			});
		},
		goForBanner(b){
			if(chkURL(b.url)){
				if (window.plus) {
					plus.runtime.openURL(b.url);
				} else {
					window.open(b.url);
				}
			}
		}
	}
};
</script>




// WEBPACK FOOTER //
// src/components/Shop.vue